/* PipiPanda Landing Page (Split-Test Offer A/B)
   Eigenständige Logik für die lp-* Sections.
   Daten kommen aus window.PipiPandaLP (gerendert in lp-buy-box.liquid). */
(function () {
  'use strict';
  var LP = window.PipiPandaLP;
  var buyBox = document.getElementById('lp-buy');
  if (!LP || !buyBox) return;

  var state = {
    size: LP.defaultSize,
    paket: LP.defaultPaket,
    qty: LP.defaultQty,
    patternIdx: 0,
    mixMode: 'self',
    pads: []
  };

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- Galerie ---------- */
  var galMain = $('#lp-gal-main');
  var galThumbs = $$('#lp-gal-thumbs button');
  galThumbs.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (galMain) galMain.src = btn.dataset.src;
      galThumbs.forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Mobile: nach links/rechts wischen wechselt das Bild
  var galBox = $('.gal-main');
  if (galBox && galThumbs.length > 1) {
    var swX = 0, swY = 0;
    galBox.addEventListener('touchstart', function (e) {
      swX = e.touches[0].clientX; swY = e.touches[0].clientY;
    }, { passive: true });
    galBox.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - swX;
      var dy = e.changedTouches[0].clientY - swY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return; // nur klare Horizontal-Swipes
      var cur = 0;
      galThumbs.forEach(function (b, i) { if (b.classList.contains('active')) cur = i; });
      var next = cur + (dx < 0 ? 1 : -1);
      if (next < 0) next = galThumbs.length - 1;
      if (next >= galThumbs.length) next = 0;
      galThumbs[next].click();
    }, { passive: true });
  }

  /* ---------- Muster-Swatches ---------- */
  $$('#lp-patterns button').forEach(function (btn, i) {
    btn.addEventListener('click', function () {
      state.patternIdx = i;
      var nameEl = $('#lp-pat-name');
      if (nameEl) nameEl.textContent = LP.patterns[i] ? LP.patterns[i].n : '';
      $$('#lp-patterns button').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      if (galMain && LP.patterns[i]) galMain.src = LP.patterns[i].img;
      buildPads();
    });
  });

  /* ---------- Größe ---------- */
  $$('#lp-sizes button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      $$('#lp-sizes button').forEach(function (b) { b.classList.remove('active'); b.setAttribute('aria-checked', 'false'); });
      btn.classList.add('active');
      btn.setAttribute('aria-checked', 'true');
      state.size = btn.dataset.s;
      var el = $('#lp-size-name');
      if (el) el.textContent = state.size;
    });
  });

  /* ---------- Bundles ---------- */
  function syncBundle(card) {
    $$('#lp-bundles .bundle').forEach(function (b) { b.classList.remove('active'); b.setAttribute('aria-checked', 'false'); });
    card.classList.add('active');
    card.setAttribute('aria-checked', 'true');
    var d = card.dataset;
    state.paket = d.paket;
    state.qty = parseInt(d.qty, 10);
    var disc = parseInt(d.disc, 10) || 0;

    $('#lp-price-now').textContent = d.unit;
    $('#lp-price-was').textContent = disc > 0 ? LP.baseUnit : '';
    var saveEl = $('#lp-price-save');
    saveEl.textContent = disc > 0 ? disc + '% sparen' : '';
    saveEl.style.display = disc > 0 ? '' : 'none';
    $('#lp-price-note').textContent = 'pro Stück · ' + d.qty + ' Stück für ' + d.now + ' · ' + d.ship;
    $('#lp-atc-sub').textContent = d.saved
      ? d.qty + ' Stück · ' + d.now + ' · spare ' + d.saved
      : d.qty + ' Stück · ' + d.now + ' · ' + d.ship;
    $('#lp-st-t').textContent = d.qty + ' Stück · ' + d.now;
    $('#lp-st-p').textContent = d.unit + ' / Stück · ' + d.ship;
    buildPads();
  }
  $$('#lp-bundles .bundle').forEach(function (card) {
    card.addEventListener('click', function () { syncBundle(card); });
  });

  /* ---------- Muster-Mix ---------- */
  $$('#lp-mixmode button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      $$('#lp-mixmode button').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      state.mixMode = btn.dataset.mode;
      state.pads = []; // bei Modus-Wechsel neu aufbauen (mix = auto, self = leer)
      buildPads();
    });
  });

  var editingSlot = -1;

  /* ---------- Popup zum Muster wählen ---------- */
  function openModal(slot) {
    var modal = $('#lp-mix-modal');
    var grid = $('#lp-mix-modal-grid');
    var title = $('#lp-modal-title');
    if (!modal || !grid) return;
    editingSlot = slot;
    if (title) title.textContent = 'Muster für Höschen ' + (slot + 1) + ' wählen';
    grid.innerHTML = '';
    LP.patterns.forEach(function (p, idx) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lp-mix-pick' + (state.pads[slot] === idx ? ' selected' : '');
      b.title = p.n;
      b.setAttribute('aria-label', p.n);
      b.innerHTML = '<img src="' + p.img + '" alt=""><span class="lp-mix-pick-name">' + p.n + '</span>';
      b.addEventListener('click', function () {
        state.pads[editingSlot] = idx;
        closeModal();
        renderSlots();
      });
      grid.appendChild(b);
    });
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    var modal = $('#lp-mix-modal');
    editingSlot = -1;
    if (modal) { modal.hidden = true; modal.setAttribute('aria-hidden', 'true'); }
    document.body.style.overflow = '';
  }

  $$('[data-lp-modal-close]').forEach(function (el) {
    el.addEventListener('click', closeModal);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  /* ---------- Slots (leere Kästchen, eins pro Stück) ---------- */
  function renderSlots() {
    var wrap = $('#lp-mix-slots');
    var hint = $('#lp-mix-hint');
    if (!wrap) return;
    wrap.innerHTML = '';
    state.pads.forEach(function (pIdx, i) {
      var b = document.createElement('button');
      b.type = 'button';
      if (typeof pIdx === 'number') {
        var p = LP.patterns[pIdx];
        b.className = 'lp-mix-slot filled';
        b.setAttribute('aria-label', 'Höschen ' + (i + 1) + ': ' + p.n + ' – ändern');
        b.innerHTML = '<img src="' + p.thumb + '" alt=""><span class="lp-mix-slot-num">' + (i + 1) + '</span>';
      } else {
        b.className = 'lp-mix-slot empty';
        b.setAttribute('aria-label', 'Höschen ' + (i + 1) + ' – Muster auswählen');
        b.innerHTML = '<span class="lp-mix-slot-plus">+</span><span class="lp-mix-slot-pick">Wählen</span>';
      }
      b.addEventListener('click', function () { openModal(i); });
      wrap.appendChild(b);
    });
    if (hint) {
      var chosen = state.pads.filter(function (x) { return typeof x === 'number'; }).length;
      hint.textContent = chosen + ' von ' + state.qty + ' gewählt · Tippe auf ein Kästchen';
    }
  }

  function buildPads() {
    var wrap = $('#lp-mix-slots');
    var hint = $('#lp-mix-hint');
    if (!wrap || !hint) return;
    closeModal();
    // Bestehende Auswahl beibehalten; neue Slots je nach Modus füllen:
    // mix = automatische, abwechslungsreiche Mischung · self = leer
    var prev = state.pads.slice();
    state.pads = [];
    for (var i = 0; i < state.qty; i++) {
      if (typeof prev[i] === 'number') {
        state.pads.push(prev[i]);
      } else if (state.mixMode === 'mix') {
        state.pads.push(i % LP.patterns.length);
      } else {
        state.pads.push(null);
      }
    }
    renderSlots();
    if (state.mixMode === 'mix') {
      hint.textContent = 'Unsere schönste Mischung – tippe ein Kästchen zum Ändern';
    }
  }
  buildPads();

  /* ---------- Variante auflösen + Warenkorb ----------
     Keine feste Variant-ID: wird live aus der Auswahl (Größe + Paket)
     gegen product.variants aufgelöst. Reihenfolge-unabhängig, damit es
     auch funktioniert, wenn das zugewiesene Produkt die Optionen anders
     herum führt (Paket/Größe statt Größe/Paket). */
  function findVariant() {
    var size = state.size, paket = state.paket, reverse = null;
    for (var i = 0; i < LP.variants.length; i++) {
      var v = LP.variants[i];
      if (v.option1 === size && v.option2 === paket) return v;
      if (v.option1 === paket && v.option2 === size) reverse = reverse || v;
    }
    return reverse;
  }

  /* Einzel-Höschen-Varianten (Muster × Größe) für Barcode-Fulfillment.
     Beim Kauf wandern Bundle + gewählte Höschen (0 €, mit Barcode) in den Warenkorb,
     verknüpft über eine gemeinsame _bundleId. Der Wächter in theme.js entfernt die
     Komponenten automatisch, sobald das Bundle weg ist / die Menge nicht stimmt.
     ⚠️ Bei Re-Import der Höschen ändern sich die Variant-IDs -> EINZEL anpassen. */
  var EINZEL = {
    'Fuchs Garten':     { S: 54659569779017, M: 54659569811785, L: 54659569844553 },
    'Zauber Einhorn':   { S: 54659569910089, M: 54659569942857, L: 54659569975625 },
    'Giraffen Safari':  { S: 54659570008393, M: 54659570041161, L: 54659570073929 },
    'Wal Abenteuer':    { S: 54659570106697, M: 54659570139465, L: 54659570172233 },
    'Weltraum Freunde': { S: 54659570205001, M: 54659570237769, L: 54659570270537 },
    'Spaßiger Pinguin': { S: 54659570336073, M: 54659570368841, L: 54659570401609 },
    'Wolken Traum':     { S: 54659570434377, M: 54659570467145, L: 54659570499913 },
    'Hasen Herzen':     { S: 54659570532681, M: 54659570565449, L: 54659570598217 }
  };

  var adding = false;
  function addToCart() {
    if (adding) return;
    var v = findVariant();
    var btn = $('#lp-atc');
    if (!v) { if (btn) btn.firstChild.textContent = 'Variante nicht verfügbar'; return; }

    // Im Selbst-Zusammenstellen-Modus müssen alle Höschen gewählt sein
    if (state.mixMode !== 'mix') {
      var offen = state.pads.filter(function (x) { return typeof x !== 'number'; }).length;
      if (offen > 0) {
        if (btn) {
          btn.firstChild.textContent = 'Bitte alle ' + state.qty + ' Muster wählen';
          setTimeout(function () { btn.firstChild.textContent = 'In den Warenkorb'; }, 2500);
        }
        return;
      }
    }

    adding = true;
    if (btn) { btn.disabled = true; }

    var namen = state.pads.map(function (pIdx) {
      return (typeof pIdx === 'number' && LP.patterns[pIdx]) ? LP.patterns[pIdx].n : null;
    });
    var muster = namen.map(function (n) { return n || 'Überraschung'; }).join(', ');

    // Eindeutige Bundle-ID: verknüpft das Bundle mit seinen Komponenten
    var bundleId = 'pp-' + Date.now().toString(36) + '-' + Math.floor(Math.random() * 1e9).toString(36);

    // 1) Bundle (trägt den Preis)
    var items = [{
      id: v.id,
      quantity: 1,
      properties: {
        'Auswahl': state.mixMode === 'mix' ? 'Schönste Mischung' : 'Eigene Zusammenstellung',
        'Größe': state.size,
        'Muster': muster,
        '_bundleId': bundleId
      }
    }];

    // 2) Komponenten = einzelne Höschen mit Barcode (0 €).
    //    Gleiches Muster mehrfach gewählt -> EINE Position mit passender Menge
    //    (_perBundle = wie oft dieses Muster pro Bundle gewählt wurde).
    var counts = {};
    namen.forEach(function (n) { if (n) counts[n] = (counts[n] || 0) + 1; });
    Object.keys(counts).forEach(function (n) {
      var map = EINZEL[n];
      var vid = map && map[state.size];
      if (vid) {
        items.push({
          id: vid,
          quantity: counts[n],
          properties: {
            '_set': state.qty + 'er-Paket',
            '_groesse': state.size,
            '_bundleId': bundleId,
            '_perBundle': String(counts[n])
          }
        });
      }
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Fehler beim Hinzufügen'); });
        return res.json();
      })
      .then(function () {
        if (btn) { btn.disabled = false; btn.firstChild.textContent = 'Hinzugefügt ✓'; }
        // Cart-Drawer des Themes öffnen (Toggle lädt den Warenkorb neu + korrigiert den Zähler)
        var toggle = document.getElementById('cart-toggle');
        if (toggle) toggle.click(); else window.location.href = '/cart';
        setTimeout(function () { if (btn) btn.firstChild.textContent = 'In den Warenkorb'; }, 2000);
      })
      .catch(function (err) {
        if (btn) {
          btn.disabled = false;
          btn.firstChild.textContent = err.message || 'Fehler, bitte erneut versuchen';
          setTimeout(function () { btn.firstChild.textContent = 'In den Warenkorb'; }, 3000);
        }
      })
      .finally(function () { adding = false; });
  }
  var atcBtn = $('#lp-atc');
  if (atcBtn) atcBtn.addEventListener('click', addToCart);

  /* ---------- Sticky Mobile Bar ---------- */
  var sticky = $('#lp-sticky-atc');
  if (sticky) {
    window.addEventListener('scroll', function () {
      var r = buyBox.getBoundingClientRect();
      if (r.bottom < 80) sticky.classList.add('show'); else sticky.classList.remove('show');
    }, { passive: true });
    var stBtn = sticky.querySelector('button');
    if (stBtn) stBtn.addEventListener('click', function () {
      buyBox.scrollIntoView({ behavior: 'smooth' });
    });
  }

  /* ---------- Scroll-zu-Kaufbox-Buttons ---------- */
  $$('[data-lp-scroll-buy]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      buyBox.scrollIntoView({ behavior: 'smooth' });
    });
  });

  /* ---------- Tabs ---------- */
  $$('.lp-tab-btns button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      $$('.lp-tab-btns button').forEach(function (b) { b.classList.remove('active'); });
      $$('.lp-tab-panel').forEach(function (p) { p.classList.remove('active'); });
      btn.classList.add('active');
      var panel = document.getElementById(btn.dataset.tab);
      if (panel) panel.classList.add('active');
    });
  });

  /* ---------- FAQ Accordion ---------- */
  $$('.lp-faq .faq-q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.parentElement;
      var a = item.querySelector('.faq-a');
      var wasOpen = item.classList.contains('open');
      $$('.lp-faq .faq-item').forEach(function (x) {
        x.classList.remove('open');
        x.querySelector('.faq-a').style.maxHeight = null;
      });
      if (!wasOpen) {
        item.classList.add('open');
        a.style.maxHeight = a.scrollHeight + 'px';
      }
    });
  });
})();
